import { buildType } from './definitions.js';

/**
 * Shared config for both web and electron applications
 */

export const isDebugBuild = buildType === 'debug';

export const APP_DISPLAY_NAME = 'Liquid Noble';
